import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, maintenanceFeatureKey } from '../reducers/maintenance.reducer';

const selectUserState = createFeatureSelector<State>(maintenanceFeatureKey);

export const watchMaintenanceMode = createSelector(selectUserState, state => state.watchedMaintenanceModeFlag);
export const getMaintenanceMode = createSelector(watchMaintenanceMode, watchedMaintenanceModeFlag => watchedMaintenanceModeFlag);
